import { canGetOrganizationSettingsPage } from "@/route-authorization";

export const organization = {
  routes: [
    // {
    //   path: "/organization",
    //   component: () => import("../dashboard"),
    //   meta: { rules: [canGetOrganizationSettingsPage] },
    // },

    {
      path: "/organization/members",
      component: () => import("../organization-members-view"),
      meta: { rules: [canGetOrganizationSettingsPage] },
    },
    {
      path: "/organization/settings",
      component: () => import("../organization-settings"),
      meta: { rules: [canGetOrganizationSettingsPage] },
    },
  ],
};
